export default (theme) => ({
  videoSession: {
    backgroundColor: '#79797960',
    width: '100vw',
    height: '100vh',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  roomHeader: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
    padding: '0 20px',
    width: 'calc(100% - 20px)',
    textAlign: 'center',
  },
  roomWrapper: {
    '& > :first-child': {
      width: 'calc(100% / 12 * 8 - 10px)',
      height: '100%',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      marginTop: 10,
    },
  },
  mobileRoomWrapper: {
    '& > :first-child': {
      display: 'none',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '0 24px 0 0',
    },
  },
  settingsButton: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    '& svg': {
      width: 25,
      height: 25,
    },
    '&:hover svg': {
      fill: theme.palette.primary.main,
    },
    [theme.breakpoints.down('md')]: {
      right: 20,
      top: 20,
      position: 'absolute',
    },
    [theme.breakpoints.down('md')]: {
      top: 17,
    },
  },
  settingsIcon: {
    fill: theme.palette.font.main,
    transition: 'fill .2s linear',
  },
  sessionWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    background: theme.palette.background.white,
    padding: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xl')]: {
      padding: '10px 30px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '10px 0 0 0',
    },
  },
  mediumSessionWrapper: {
    borderRadius: 33,
    width: '70%',
    height: '90%',
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('xl')]: {
      width: '90%',
      height: '90%',
    },
    [theme.breakpoints.down('md')]: {
      width: '95%',
      height: '95%',
    },
    [theme.breakpoints.down('sm')]: {
      height: '98%',
    },
  },
  chat: {
    width: 'calc(100% / 12 * 4 - 10px)',
    borderRadius: 33,
    border: `1px solid ${theme.palette.disabled.main}`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  activeMobileChat: {
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: 'calc(100% - 20px)',
      margin: 10,
    },
  },
  participantsWrapper: {
    height: '100%',
    overflowY: 'auto',
    width: '100%',
  },
  chatParticipantsWrapper: {
    height: 200,
  },
  participants: {
    borderRadius: 33,
    border: `1px solid ${theme.palette.disabled.main}`,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      height: 300,
    },
    [theme.breakpoints.down('sm')]: {
      height: 200,
    },
  },
  closeButton: {
    position: 'absolute',
    top: 35,
    right: 20,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    '& svg': {
      transition: 'fill .2s linear',
      '&:hover': {
        fill: theme.palette.primary.main,
      },
    },
  },
  controlButton: {
    maxWidth: 290,
    width: '100%',
    margin: '20px auto',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100% - 32px)',
    },
  },
  refreshButtonIcon: {
    minWidth: 23,
    minHeight: 23,
    width: 23,
    height: 23,
    fill: theme.palette.background.white,
  },
  controlButtonText: {
    marginLeft: 10,
    fontSize: 14,
  },
  callEndMessage: {
    padding: 45,
    boxSizing: 'border-box',
    margin: 'auto',
    textAlign: 'center',
    borderRadius: 33,
    border: `1px solid ${theme.palette.disabled.main}`,
    maxWidth: '90%',
    width: 'auto',
  },
  videoSettingsScrollWrap: {
    width: '100%',
    margin: 'auto',
    overflowY: 'auto',
    paddingRight: 50,
    [theme.breakpoints.down('md')]: {
      paddingRight: 5,
    },
  },
  videoSettings: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '87%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 1001,
    background: theme.palette.background.white,
    padding: '50px 0 50px 50px',
    borderRadius: 33,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('xl')]: {
      padding: '30px 0 30px 30px',
    },
    [theme.breakpoints.down('md')]: {
      width: '80%',
      height: '70%',
      padding: '30px 0 0 0',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      height: '95%',
      padding: 10,
    },
  },
  platformActionsButtons: {
    position: 'absolute',
    top: 8,
    left: 202,
    display: 'flex',
    gap: 8,
    '&:div': {
      marginRight: 8,
    },
  },
  platformActionsButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: 8,
    background: 'rgba(0,0,0,0.56)',
    transition: 'background 100ms linear',
    color: '#ffffff',
    fontWeight: 'bold',
    '&:hover': {
      color: 'white',
      background: 'rgba(0,0,0,0.72)',
    },
    '&:focus': {
      outline: '2px solid #4a3aaa',
    },
  },
  precallPanel: {
    maxWidth: 408,
    width: '100%',
    margin: 'auto',
    height: 638,
    maxHeight: 638,
    backgroundColor: '#ffffff',
    borderRadius: 16,
    boxShadow: '0px 8px 16px rgba(0,0,0,0.16),0px 1px 4px rgba(0,0,0,0.16)',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
    '&:div': {
      width: '100%',
    },
  },
  precallFields: {
    flexGrow: 1,
    padding: 16,
    width: '100%',
    borderBottom: '1px solid rgba(0, 0, 0, 0.24)',
  },
  precallFooter: {
    padding: 16,
    width: '100%',
  },
  videoSessionWhereby: {
    backgroundColor: '#006654',
  },
});
